import styled from 'styled-components';
export const SelectCustom = styled.div `
  position: relative;
  height: 2.5rem;
  width: 100%;
  ${({ theme }) => `color: rgba(${theme.colors.transparentBlack}, 0.36);`}

  position: absolute;
  top: 0;
  left: 0;
  display: none;

  @media (hover: hover) {
    // Since we are using a mouse, it's safe to show the custom select.
    display: block;
    &:hover {
      background: white;
    }
  }

  ${({ $forceCustom }) => $forceCustom && `
      display: block;
      &:hover {
        background: white;
      }
  `}
`;
